import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.less']
})
export class ErrorAlertComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
